<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>

          <b-card>
            <div slot="header">DD.JJ.</div>
            <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Impuesto"
                  label-for="proveedor"
                  :label-cols="2"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        v-if="!comprobanteCancelado"
                        class="filter-search-icons" 
                        @click="seleccionarImpuesto">
                      <b-input-group-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="proveedor"
                      :value="proveedorNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  v-if="!comprobanteCancelado"
                  label="Total"
                  label-for="total"
                  :label-cols="2"
                  horizontal>
                  <b-form-input 
                    id="total"
                    v-model.trim= "$v.total.$model" 
                    :state="totalValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="totalFeedback">
                    {{ totalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="comprobanteCancelado"
                  label="Total"
                  label-for="total"
                  :label-cols="2"
                  horizontal>
                  <b-form-input 
                    id="total"
                    :value= "total | moneda" 
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <!-- <b-form-group
                  label="Número"
                  label-for="numero"
                  :label-cols="2"
                  horizontal>
                  <b-input-group>
                    <b-form-input 
                      id="numero"
                      v-model.trim= "$v.numero.$model" 
                      :state="numeroValido"
                      type="number"
                      @blur.native="validate">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="numeroFeedback">
                    {{ numeroInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group> -->
              </b-col>

              <b-col xl="6">
                <b-form-group
                  label="Fecha Comp."
                  label-for="fechaComprobante"
                  :label-cols="3"
                  horizontal>
                  <b-form-input 
                    id="fechaComprobante" 
                    v-model= "fechaComprobante" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Periodo"
                  label-for="periodo"
                  :label-cols="3"
                  v-if="!impuestoPresentacionAnual"
                  horizontal>
                  <b-form-select 
                    v-model="periodoMesNombre" 
                    :options="meses" 
                    :state="periodoValido"
                    class="mb-3 select-fecha select-fecha-mes"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value="null">Seleccione un mes</option>
                      <!--<option :value='null' :disabled='Boolean(true)'>Seleccione un mes</option>-->
                    </template>
                  </b-form-select>
                  <b-form-select 
                    v-model="periodoAnio" 
                    :options="anios" 
                    :state="periodoValido"
                    class="mb-3 select-fecha select-fecha-anio"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value="0">Seleccione un año</option>
                      <!--<option :value="0" :disabled='Boolean(true)'>Seleccione un año</option>-->
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="periodoFeedback">
                    {{ periodoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Periodo"
                  label-for="periodo"
                  :label-cols="3"
                  v-if="impuestoPresentacionAnual"
                  horizontal>
                  <b-form-select 
                    v-model="periodoAnio" 
                    :options="anios" 
                    :state="periodoValido"
                    class="mb-3"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value="0">Seleccione un año</option>
                      <!--<option :value="0" :disabled='Boolean(true)'>Seleccione un año</option>-->
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="periodoFeedback">
                    {{ periodoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Total"
                  label-for="total"
                  :label-cols="2"
                  horizontal>
                  <b-form-input 
                    id="total"
                    v-model.trim= "$v.total.$model" 
                    :state="totalValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="totalFeedback">
                    {{ totalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row> -->
          </b-card>

          <b-card header="Cuentas">
            <app-compra-cuentas
              @agregarCuenta="agregarCuenta"
              @editarCuenta="editarCuenta"
              @borrarCuenta="borrarCuenta">
            </app-compra-cuentas>  
          </b-card>

          <b-form-group
            label-for="observaciones">
            <b-form-textarea
              id="observaciones"
              v-model="$v.observaciones.$model" 
              rows="3"
              max-rows="6"
              :state="observacionesValidas"
              @blur.native="validate">
            </b-form-textarea>
            <b-form-invalid-feedback id="observacionesFeedback">
              {{ observacionesInvalidasMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="compraCuentaModal" 
        title="Información de la Cuenta"
        header-bg-variant= "light" 
        hide-footer
        hide-header-close
        modal-class="modalABM"
        lazy>
      <app-compra-cuenta
        :cuentas="planCuentas" 
        :cuentasList="planCuentasList"
        @updateCompraCuenta="updateCompraCuenta"
        @closeCompraCuenta="closeCompraCuentaModal">
      </app-compra-cuenta>  
    </b-modal>

    <b-modal ref="searchImpuestoModal" 
        title="Seleccionar Impuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-impuesto
        @impuestoSeleccionado="impuestoSeleccionado">
      </app-search-impuesto>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import { required, decimal, minValue, maxValue, numeric, maxLength, minLength, between } from 'vuelidate/lib/validators';
import SearchImpuesto from '../impuestos/SearchList.vue'
import ABMButtons from '../shared/abmButtons.vue';
import CompraCuenta from './CompraCuenta.vue'
import CompraCuentas from './CompraCuentas.vue'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { msjAlert } from '../../mixins/msjAlert';
import moment from 'moment';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compraImpuesto/getField',
  mutationType: 'compraImpuesto/updateField',
});

export default {
  name: 'ABM',
  components: {
    appSearchImpuesto: SearchImpuesto,
    appCompraCuenta: CompraCuenta,
    appCompraCuentas: CompraCuentas,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal,
    msjAlert 
  ],
  data () {
    return {
      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',
      proveedorValido: null,
      proveedorInvalidoMsj: '',
      periodoValido: null,
      periodoInvalidoMsj: '',
      // numeroValido: null,
      // numeroInvalidoMsj: '',
      totalValido: null,
      totalInvalidoMsj: '',

      inicializando: Boolean(false),
      tableBusy: false,
      readOnly: Boolean(true),

      meses: [],
      anios: [],
      planCuentas: [],
      planCuentasList: [],
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaComprobante',
      'periodo',
      'periodoMesNombre',
      'periodoAnio',
      'proveedorNombre',
      'impuestoPresentacionAnual',
      // 'numero',
      'cuentas',
      'total', 
      'observaciones',

      'cuentaSelected',
      'comprobanteCancelado'
    ]),
  },
  created() {
    //console.log(this.ordenesProveedor);

    this.getDatosAdicionales();
    
    let compraImpuestoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        compraImpuestoId = this.$route.params.id;
      }
    }

    let params = {
      compraImpuestoId,
    }

    this.inicializando = true;
    this.showSpinner();
    this.$store.dispatch('compraImpuesto/inicializar', params)
      .then(() => {
        this.inicializando = false;
        if (this.comprobanteCancelado) {
          this.showAlertError('La declaración jurada ha sido cancelada total o parcialmente. Algunos valores no pueden ser modificados.');
        }
      })
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      vm.meses = vm.getMeses();
      vm.anios = vm.getAniosPeriodo();

      vm.planCuentas = [];
      vm.planCuentasList = [];
      this.$store.dispatch('cuentas/getList')
        .then(() => {
          vm.planCuentas = this.$store.getters['cuentas/list']
          vm.planCuentasList = this.$store.getters['cuentas/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cuentas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      // if (campo == 'numero' || validarTodos) {
      //   if (this.$v.numero.$error) {
      //     this.numeroValido = false;
      //     if (!this.$v.numero.required) {
      //       this.numeroInvalidoMsj = 'Debe ingresar el número del comprobante.';
      //     } else if (!this.$v.numero.numeric || !this.$v.numero.minValue || !this.$v.numero.maxValue) {
      //       this.numeroInvalidoMsj = 'El número de comprobante ingresado no es válido.';
      //     } 
      //   } else {
      //     this.numeroValido = null;
      //     this.numeroInvalidoMsj = '';
      //   }
      // }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 500 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let mes = this.getMesNumero(this.periodoMesNombre);
      let anio = parseInt(this.periodoAnio);

      if (!this.isValidDate(1, mes, anio))
      {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período del comprobante.';
        save = Boolean(false);
      } else {
        this.periodoValido = null;
        this.periodoInvalidoMsj = '';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('compraImpuesto/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.go(-1);
    },
    seleccionarImpuesto() {
      this.$refs.searchImpuestoModal.show()
    },
    impuestoSeleccionado(item) {
      this.$store.dispatch('compraImpuesto/setProveedor', item)
      this.$refs.searchImpuestoModal.hide();
    },
    agregarCuenta(item) {
      this.cuentaSelected = null
      this.$refs.compraCuentaModal.show()
    },
    editarCuenta(item) {
      this.cuentaSelected = item
      this.$refs.compraCuentaModal.show()
    },
    borrarCuenta(item) {
      this.cuentaSelected = item
      this.$store.dispatch('compraImpuesto/deleteCuenta')
    },

    updateCompraCuenta(compraCuenta) {
      this.$store.dispatch('compraImpuesto/setCuenta', compraCuenta)
      this.$refs.compraCuentaModal.hide()
    },
    closeCompraCuentaModal() {
      this.$refs.compraCuentaModal.hide()
    },
  },
  validations: {
    // numero: {
    //   required,
    //   numeric,
    //   minValue: minValue(1),
    //   maxValue: maxValue(99999999)
    // },
    total: { 
      decimal, 
      minValue: minValue(0) 
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
    'total' : function(newVal, oldVal) {
      this.$store.dispatch('compraImpuesto/actualizarTotal')
    },
  },
}
</script>

<style>
</style>
